const orderFormElements = document.querySelectorAll('order-form');
orderFormElements.forEach(orderFormItem => {
  const btnSubscribe = orderFormItem.querySelector('#btn-subscribe');
  const btnOneTime = orderFormItem.querySelector('#btn-onetime');
  const giftInputs = orderFormItem.querySelectorAll('.gift-input');
  const form = orderFormItem.querySelector('#order-form-cart');
  const button = orderFormItem.querySelector('#btn-atc');
  const privacySubscribe = orderFormItem.querySelector('#privacy-subscribe');
  const privacyOnetime = orderFormItem.querySelector('#privacy-onetime');

  btnSubscribe.addEventListener('click', () => {
    console.log('click')
    giftInputs.forEach(input => {
      input.removeAttribute('disabled');
    });

    if (privacySubscribe) privacySubscribe.classList.remove('hidden');
    if (privacyOnetime) privacyOnetime.classList.add('hidden');
  })

  btnOneTime.addEventListener('click', () => {
    giftInputs.forEach(input => {
      input.setAttribute('disabled', '');
    });

    if (privacySubscribe) privacySubscribe.classList.add('hidden');
    if (privacyOnetime) privacyOnetime.classList.remove('hidden');
  })

  button && button.addEventListener('click', (e) => {
    if (giftInputs.length && !giftInputs[0]?.hasAttribute('disabled')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const MAIN_VARIANT_ID = Number(form.querySelector('#order-form-variant-id')?.value);
      const NESTED_VARIANT_ID = Number(form.querySelector('.gift-input-id')?.value);
      const QUANTITY = Number(form.querySelector('#order-form-quantity')?.value);
      const SELLING_PLAN_INPUT = form.querySelector('#order-form-selling-plan');
      const MAIN_VARIANT_SELLING_PLAN_ID = SELLING_PLAN_INPUT?.value || null;

      if (!MAIN_VARIANT_ID || !NESTED_VARIANT_ID || !QUANTITY) {
        console.error('Missing required variant IDs or quantity');
        return;
      }

      const formData = {
        items: [
          {
            id: MAIN_VARIANT_ID,
            quantity: QUANTITY,
            ...(MAIN_VARIANT_SELLING_PLAN_ID && { selling_plan: MAIN_VARIANT_SELLING_PLAN_ID })
          },
          {
            id: NESTED_VARIANT_ID,
            quantity: 1,
            parent_id: MAIN_VARIANT_ID
          }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(data => {
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
    }
  });

});